import { widgetMap } from "../engine/widgetMap";

export default function WorldSectionRenderer({
  section,
  value = {},
  onChange,
  mode,
  feedback
}) {
  const Widget = widgetMap[section.type];

  return (
    <Widget
      section={section}
      id={section.id}
      config={section.config}
      value={value}
      onChange={onChange}
      mode={mode}
      feedback={feedback}
    />
  );
}
